// extracted by mini-css-extract-plugin
module.exports = {"image":"imageWrapper_image__IhGc_"};